const legacySites = ['mybag', 'beautyexpert', 'hqhair', 'zavvi', 'zavvies', 'toblerone', 'preloved'];

export default function isLegacySite(siteCode) {
  return legacySites.includes(siteCode);
}
